import React from 'react'
import { Link } from 'react-router-dom'
import Service_1 from '../../../assets/images/services/01.png'
import Service_2 from '../../../assets/images/services/02.png'
import Service_3 from '../../../assets/images/services/03.png'
import Service_4 from '../../../assets/images/services/04.png'

const Service = () => {
    return (
        <>
            <section id="services" className="services-main-block">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-3 col-lg-6 col-md-6">
                            <div className="services-block">
                                <div className="services-img-four">
                                    <img
                                        src={Service_1}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </div>
                                <div className="services-dtls">
                                    <h4 className="services-heading">
                                        <Link to="#" title="">
                                            Free Shipping
                                        </Link>
                                    </h4>
                                    <p>Day by Day Delivery</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6">
                            <div className="services-block">
                                <div className="services-img-four">
                                    <img
                                        src={Service_2}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </div>
                                <div className="services-dtls">
                                    <h4 className="services-heading">
                                        <Link to="#" title="">
                                            Amazing Deals
                                        </Link>
                                    </h4>
                                    <p>Enjoy Offers</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6">
                            <div className="services-block">
                                <div className="services-img-four">
                                    <img
                                        src={Service_3}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </div>
                                <div className="services-dtls">
                                    <h4 className="services-heading">
                                        <Link to="#" title="">
                                            Expert Teams
                                        </Link>
                                    </h4>
                                    <p>Best Performers</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6">
                            <div className="services-block">
                                <div className="services-img-four">
                                    <img
                                        src={Service_4}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </div>
                                <div className="services-dtls">
                                    <h4 className="services-heading">
                                        <Link to="#" title="">
                                            Support Center
                                        </Link>
                                    </h4>
                                    <p>Super Services</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Service
